import React from 'react';
import { FileInput } from '@youngcapital/component-library';
import PropTypes from 'prop-types';

import { acceptedFiles } from '../../../helpers/util';

const FileInputWrapper = ({ getFieldProps, t }) => {
  const fileInputProps = getFieldProps('upload_cv');
  const handleDeleteFile = () => {
    fileInputProps.setValue('');
  };

  const handleAddFile = ({ files }) => {
    const file = files[0];
    fileInputProps.setValue(file);
  };

  return (
    <>
      <hr />
      <div className='mb-2x pb-1x' data-cy='upload'>
        <FileInput
          {...fileInputProps}
          label={t('cv_fieldset.your_cv')}
          accept={acceptedFiles}
          onAddFile={handleAddFile}
          onDeleteFile={handleDeleteFile}
          inputProps={{
            title: 'file-input'
          }}
        />
      </div>
    </>
  );
};

FileInputWrapper.propTypes = {
  getFieldProps: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default FileInputWrapper;
